/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrValueTypename = "PhrValue" as const;

/**
 *
 * @export
 * @interface PhrValue
 */
export interface PhrValue {
  /**
   *
   * @type {string}
   * @memberof PhrValue
   */
  unit?: string;
  /**
   *
   * @type {number}
   * @memberof PhrValue
   */
  value?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrValue
   */
  readonly __typename?: string;
}

export function PhrValueFromJSON(json: any): PhrValue {
  return PhrValueFromJSONTyped(json, false);
}

export function PhrValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrValue {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrValueTypename,

    unit: !exists(json, "unit") ? undefined : json["unit"],
    value: !exists(json, "value") ? undefined : json["value"] == "" ? undefined : json["value"],
  };
}

export function PhrValueToJSON(object?: PhrValue | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    unit: value.unit,
    value: (value.value as unknown as string) == "" ? undefined : value.value,
  };
}
